import React, { useEffect, useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  CustomModal,
  SingleInputField,
  TwoInputField,
} from "../../../components";
import { inventoryProductsData } from "../../../assets/lib/inventoryProduts";

const useStyles = makeStyles({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
});

const AddInventory = (props) => {
  const {
    isModalOpenForProduct,
    setIsModalOpenForProduct,
    handleSubmitModalforProducts,
    productState,
    getProductInput,
    loadingModal,
    productData,
  } = props;

  const classes = useStyles();
  const isPhone = useMediaQuery("(max-width: 390px)");

  const [anchorElProducts, setAnchorElProducts] = useState(null);
  const [productMenu, setProductMenu] = useState(null);
  const [productPrice, setProductPrice] = useState(0);
  const [expiry, setExpiry] = useState("");

  const handleOpenMenu = (event) => {
    setAnchorElProducts(event.currentTarget);
  };

  const onChangeMenuItemProducts = (item) => {
    setProductMenu(item);
    setProductPrice(item.unitPrice || 0);

    // Set expiry date
    const newDate = new Date();
    newDate.setDate(newDate.getDate() + item.expiry);
    setExpiry(newDate.toDateString());

    setAnchorElProducts(null);

    // Update form state
    getProductInput({ target: { name: "productId", value: item.productId, type: "text" } });
    getProductInput({ target: { name: "productName", value: item.productName, type: "text" } });
  };

  // Set default selected product on mount
  useEffect(() => {
    if (productData.length > 0 && !productMenu) {
      const first = productData[0];
      setProductMenu(first);
      setProductPrice(first.unitPrice || 0);

      // Calculate and set expiry
      const newDate = new Date();
      newDate.setDate(newDate.getDate() + first.expiry);
      setExpiry(newDate.toDateString());

      getProductInput({ target: { name: "productId", value: first.productId, type: "text" } });
      getProductInput({ target: { name: "productName", value: first.productName, type: "text" } });
    }
  }, [productData]);

  return (
    <CustomModal
      heading={"Add Products"}
      open={isModalOpenForProduct}
      onClose={() => setIsModalOpenForProduct(false)}
      onSubmit={handleSubmitModalforProducts}
      showLoading={loadingModal}
    >
      <div className={classes.formContainer}>
        {/* Product Dropdown */}
        <div className={classes.formGroup}>
          <span className={classes.formLabel} style={{ fontSize: isPhone ? "12px" : "inherit" }}>
            <b>Products :</b>
          </span>
          <Button
            aria-controls="dropdown-menu"
            aria-haspopup="true"
            onClick={handleOpenMenu}
            variant="contained"
            color="primary"
            style={{
              textTransform: "none",
              fontSize: isPhone ? "12px" : "16px",
              marginLeft: "20px",
              width: "200px",
            }}
            endIcon={<KeyboardArrowDownIcon />}
          >
            {productMenu?.productName || "Select Product"}
          </Button>

          <Menu
            id="dropdown-menu"
            anchorEl={anchorElProducts}
            keepMounted
            open={Boolean(anchorElProducts)}
            onClose={() => setAnchorElProducts(null)}
          >
            {productData.map((product, index) => (
              <MenuItem key={index} onClick={() => onChangeMenuItemProducts(product)}>
                {product?.productName}
              </MenuItem>
            ))}
          </Menu>
        </div>

        {/* Quantity and Expiry */}
        <TwoInputField
          content={inventoryProductsData.quantity}
          value={productState.quantity}
          secondContent={inventoryProductsData.expiry}
          secondValue={expiry}
          getInputData={getProductInput}
        />

        {/* Total Price (calculated manually) */}
        <SingleInputField
          content={inventoryProductsData.unitPrice}
          value={productPrice * (productState.quantity || 0)}
          style={{ width: "100px" }}
          isEditable={false}
          getInputData={() => {}}
        />
      </div>
    </CustomModal>
  );
};

export default AddInventory;
